import { type MetaFunction, useLoaderData } from "@remix-run/react";
import Container from "~/components/layout/Container";
import { buildMeta } from "~/lib/seo";
import { references } from "../_index";
import OfferBanner from "../features/OfferBanner";
import References from "../features/References";
import ServicesComponent from "../features/Services";
import Slogans from "../features/Slogans";
import { HizmetListesi } from "../hizmetlerimiz+/_index";

export const loader = async () => {
  return {
    services: HizmetListesi,
    references: references
  }
}
export const meta: MetaFunction = () =>
  buildMeta({
    title: "Hakkımızda | Al-De Mühendislik",
    description:
      "Al-De Mühendislik; 20 yıllık deneyimi ve uzman kadrosuyla Manisa, İzmir, Turgutlu ve Akhisar'da ısıtma, soğutma ve mekanik tesisat çözümleri sunan müşteri odaklı bir şirkettir.",
    path: "/hakkimizda",
  })
export default function Page() {
  const { services, references } = useLoaderData<typeof loader>();
  return (
    <div className="mt-48">
      <Container className="flex-wrap py-12">
        <div className="text-[24px] font-lato text-[#444444] pb-20 flex flex-wrap items-start">
          <div className="w-full md:w-1/3 mb-10 flex flex-wrap items-center justify-center">
            <img src="/assets/hakkimizda.webp" alt="Al-De Mühendislik" width={500} height={375} loading="lazy" className="w-full mb-10" />
            <img src="/assets/AL-DE-muhendislik-logo.svg" alt="Al-De Mühendislik" width={400} height={150} loading="lazy" className="w-10/12" />
          </div>
          <div className="text-[18px] font-lato text-[#444444] w-full md:w-2/3 pl-12">
            <h1 className="text-[32px] font-black font-source-sans-pro w-full mb-6">Hakkımızda</h1>
            <h2 className="text-[24px] font-black font-source-sans-pro ">Biz Kimiz?</h2>
            Biz, AL-DE Mühendislik, sektördeki yılların deneyimi ve birikimiyle, müşteri odaklı hizmet anlayışını benimsemiş bir şirketiz. Kuruluşumuzdan bu yana, yenilikçi çözümler, kaliteli hizmet ve güvenilirlik ilkelerimizle sektördeki en iyi firmalardan biri olmayı başardık. AL-DE Mühendislik, her zaman mükemmeliyetçi yaklaşımını benimseyerek, müşterilerinin ihtiyaçlarını en iyi şekilde karşılamak ve onlara üstün hizmet sunmak için çalışmaktadır.
            <br />
            <br />
            Sektördeki uzman ekibimiz, her türlü talebe en uygun çözümleri sunmak için son teknolojiye sahip ekipmanlar ve en iyi uygulama yöntemlerini kullanmaktadır. Gelişen teknolojiye ayak uydurarak, hizmetlerimizi sürekli olarak yeniliyoruz ve sektördeki en son trendleri takip ediyoruz. Müşteri memnuniyetini her zaman ön planda tutarak, güvenilir, hızlı ve etkili çözümler sunmak için var gücümüzle çalışıyoruz.
            <br />
            <br />
            <br />
            <h3 className="text-[24px] font-black font-source-sans-pro ">Vizyonumuz</h3>
            Vizyonumuz, AL-DE Mühendislik’in sektördeki lider konumunu daha da güçlendirerek, global pazarda tanınan ve tercih edilen bir marka olmaktır. Amacımız, müşterilerimize sadece hizmet değil, aynı zamanda değer katmak, onların iş süreçlerini daha verimli ve başarılı hale getirmektir. Bu doğrultuda, sürekli olarak inovasyon ve kaliteyi ön planda tutarak, sektöre yeni standartlar getirmeyi hedefliyoruz.
            <br />
            <br />
            <br />
            <h3 className="text-[24px] font-black font-source-sans-pro ">Misyonumuz</h3>
            Misyonumuz, müşterilerimize sektördeki en kaliteli hizmeti sunmak, onlara en iyi çözümleri sunarken, aynı zamanda topluma ve çevreye duyarlı bir şekilde faaliyet göstermek. İşimizin her yönünde mükemmeliyetçi bir yaklaşımı benimseyerek, müşteri memnuniyetini en yüksek seviyeye çıkarmak için çalışıyoruz.
            <br />
            <br />
            Müşterilerimizin ihtiyaçlarını anlamak, onlara en uygun çözümleri sunmak ve onlara en iyi deneyimi yaşatmak için her adımda titizlikle hareket ediyoruz. Bizim için her müşteri, her proje özel ve değerlidir. Bu nedenle her birine kişisel yaklaşarak, güvenilir ve uzun vadeli işbirlikleri oluşturmayı amaçlıyoruz.
          </div>
        </div>
      </Container>
      <Slogans />
      <OfferBanner />
      <ServicesComponent services={services} />
      <References references={references} />
    </div>
  )
}
